import React, { Children } from 'react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <AnimatedSection staggerChildren className="py-16 md:py-24 px-6 max-w-3xl mx-auto" data-id="element-264">
      <div className="text-center mb-12" data-id="element-265">
        <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-266">
          El Problema Real
        </h2>
      </div>

      <div className="space-y-6" data-id="element-267">
        <AnimatedItem data-id="element-268">
          <div className="bg-cream rounded-xl p-6 md:p-8 border border-charcoal/5" data-id="element-269">
            <p className="text-charcoal/90 text-lg leading-relaxed mb-4" data-id="element-270">
              Vives en un estado de{' '}
              <span className="text-terracotta font-semibold" data-id="element-271">
                alerta constante
              </span>
              . Te despiertas con un nudo en el estómago y te acuestas repasando
              cada error del día.
            </p>
            <p className="text-charcoal/90 text-lg leading-relaxed" data-id="element-272">
              Tu cuerpo está saturado de{' '}
              <span className="text-terracotta font-semibold" data-id="element-273">cortisol</span>,
              la hormona del estrés.
            </p>
          </div>
        </AnimatedItem>

        <AnimatedItem data-id="element-274">
          <div className="bg-sage/10 rounded-xl p-6 md:p-8 border border-sage/20" data-id="element-275">
            <div className="flex items-start gap-4" data-id="element-276">
              <div className="mt-1 flex-shrink-0" data-id="element-277">
                <AlertCircleIcon className="w-6 h-6 text-sage" data-id="element-278" />
              </div>
              <div data-id="element-279">
                <p className="text-charcoal/90 text-lg leading-relaxed mb-4" data-id="element-280">
                  El problema es que cuando el pánico llega, tu cerebro "lógico"{' '}
                  <span className="font-semibold" data-id="element-281">se apaga</span>.
                </p>
                <p className="text-charcoal/90 text-lg leading-relaxed mb-4" data-id="element-282">
                  Por eso los consejos típicos de "cálmate" o "medita" no
                  funcionan en medio de una crisis:{' '}
                  <span className="italic" data-id="element-283">
                    estás intentando razonar con un incendio forestal mientras
                    te quemas.
                  </span>
                </p>
                <p className="text-charcoal font-semibold text-lg" data-id="element-284">
                  Para recuperar la calma, necesitas entrar por la puerta de
                  atrás: <span className="text-sage" data-id="element-285">tu sistema nervioso.</span>
                </p>
              </div>
            </div>
          </div>
        </AnimatedItem>
      </div>
    </AnimatedSection>;
}